export const ROUTE_HOMEPAGE = "/"
export const DRACO_VERSION_LIST = [
  {id: "model", label: "No compression version"},
  {id: "dracoModel0", label: "Compression0 version"},
  {id: "dracoModel1", label: "Compression1 version"},
  {id: "dracoModel3", label: "Compression3 version"},
  {id: "dracoModel6", label: "Compression6 version"}
]
